// PartA4.js - Part A4 Plans after School component with pagination

import React, { useState, useEffect } from 'react';
import { Button, message, Pagination } from 'antd';
import { SaveOutlined, ReloadOutlined } from '@ant-design/icons';
import { getAccessToken } from '../../authClient';
import PartA4PlansAfterSchool from './components/PartA4PlansAfterSchool';
import PartA4FutureSelf from './components/PartA4FutureSelf';
import { API_CONFIG } from '../../config/api';

const API_BASE_URL = API_CONFIG.BASE_URL;

const PartA4 = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    // Form data state matching the Part A4 images exactly
    const [formData, setFormData] = useState({
        // Future Self - 10 years from now
        future_improve_yourself: '',
        future_support_friends_family: '',
        future_improve_society: '',

        // How do I feel about my future? (1-10 sliders)
        feel_prepared: 5,
        feel_excited: 5,
        feel_confident: 5,
        feel_curious: 5,

        // Why do you think so? and Parents' feedback
        why_think_so: '',
        parents_feedback: '',

        // The next big step of my life - After I finish school, I want to...
        next_step_college: false,
        next_step_skill_training: false,
        next_step_professional: false,
        next_step_other: false,
        next_step_other_specify: '',

        // I plan to go to college/Skill institute/professional institute
        college_institute_name: '',
        course_skill_training: '',
        course_type_certificate: false,
        course_type_diploma: false,
        course_type_degree: false,

        // I plan to pursue a skill-based course. I would like to work...
        work_corporation: false,
        work_own_business: false,
        work_family_business: false,
        work_government: false,
        work_other: false,
        work_other_specify: '',

        // Discussion with teacher/counsellor/parent/caregiver/peer
        strengths_abilities: '',
        need_to_improve: '',
        challenges_face: ''
    });

    useEffect(() => {
        loadExistingData();
    }, []);

    const loadExistingData = async () => {
        try {
            const token = getAccessToken();
            const response = await fetch(`${API_BASE_URL}/secondary/user/hpc-profile/part-a4`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                if (data.exists && data.part_a_4) {
                    setFormData(prevData => ({
                        ...prevData,
                        ...data.part_a_4
                    }));
                }
            }
        } catch (error) {
            console.error('Error loading existing data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleCheckboxChange = (field, checked) => {
        setFormData(prev => ({
            ...prev,
            [field]: checked
        }));
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            const token = getAccessToken();
            const response = await fetch(`${API_BASE_URL}/secondary/user/hpc-profile/part-a4`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                message.success('Part A4 saved successfully!');
            } else {
                throw new Error('Failed to save Part A4');
            }
        } catch (error) {
            console.error('Error saving Part A4:', error);
            message.error('Failed to save Part A4');
        } finally {
            setSaving(false);
        }
    };

    const renderCurrentPage = () => {
        switch (currentPage) {
            case 1:
                return (
                    <PartA4PlansAfterSchool
                        formData={formData}
                        handleInputChange={handleInputChange}
                        handleCheckboxChange={handleCheckboxChange}
                    />
                );
            case 2:
                return (
                    <PartA4FutureSelf
                        formData={formData}
                        handleInputChange={handleInputChange}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <div className="part-a4-container">
            {/* Page Content */}
            {renderCurrentPage()}

            {/* Navigation and Save Controls */}
            <div className="page-controls">
                <div className="pagination-section">
                    <Pagination
                        current={currentPage}
                        total={2}
                        pageSize={1}
                        onChange={setCurrentPage}
                        showSizeChanger={false}
                        showQuickJumper={false}
                        showTotal={(total, range) => `Page ${range[0]} of ${total}`}
                    />
                </div>

                <div className="save-section">
                    <Button
                        type="primary"
                        size="large"
                        icon={<SaveOutlined />}
                        onClick={handleSave}
                        loading={saving}
                        className="save-button"
                    >
                        {saving ? 'Saving...' : 'Save Part A4'}
                    </Button>

                    <Button
                        size="large"
                        icon={<ReloadOutlined />}
                        onClick={loadExistingData}
                        className="reload-button"
                        style={{ marginLeft: '10px' }}
                    >
                        Reload Data
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default PartA4;